import { FilterValueType } from 'festo-react-ui-kit';
import { FilterBase, IFilterPreparation } from '../../features/filter/interfaces';
import { FilterValueKey } from '../../features/filter/utils';

export const hashCode = (s: string): number => {
  let h = 0;

  if (s.length > 0) {
    for (let i = 0; i < s.length; i++) {
      h = Math.imul(31, h) + s.charCodeAt(i);
    }
  }

  return h;
};

export const getFilterPreparation = ({ filter, filtersValue, t }: IFilterPreparation) => {
  if (filter.value) {
    switch (filter.type) {
      case 'range': {
        const currentRangeValue = +filtersValue[filter.key];

        if (filter.key === FilterValueKey.OUTPUT_PRESSURE && filtersValue[FilterValueKey.CALCULATION_RESULT] === 'QN') {
          const maxPressureValue = +filtersValue[FilterValueKey.SUPPLY_PRESSURE];
          filter = {
            ...filter,
            value: {
              ...filter.value,
              data: currentRangeValue,
              max: maxPressureValue,
            },
          };

          return filter;
        }

        filter = { ...filter, value: { ...filter.value, data: currentRangeValue } };

        return filter;
      }
      case 'textsegmentedbutton':
      case 'combinedsegmentedbutton': {
        if (!Array.isArray(filter.value)) return;
        const currentTextValue = filtersValue[filter.key];
        let savedModalSegment: FilterValueType[] = [];

        savedModalSegment = filter.value.map((modalSegment) => {
          if ('label' in modalSegment) {
            if (currentTextValue === modalSegment.data) {
              return {
                ...modalSegment,
                label: t(modalSegment.label),
                selected: true,
              };
            }

            return {
              ...modalSegment,
              label: t(modalSegment.label),
              selected: false,
            };
          } else {
            return {
              ...modalSegment,
              selected: false,
            };
          }
        });

        return {
          ...filter,
          value: savedModalSegment,
        };
      }
      case 'input': {
        return { ...filter, value: { ...filter.value, data: filtersValue[filter.key] } };
      }
    }
  } else if (filter.filters) {
    switch (filter.type) {
      case 'empty':
        const updatedFilterChildren = filter.filters.map((subFilter) =>
          getFilterPreparation({ filter: subFilter, filtersValue, t }),
        ) as FilterBase[];

        filter = {
          ...filter,
          filters: updatedFilterChildren,
        };

        return filter;
    }
  }

  return filter;
};
